import { SectionHeader } from "@/components/ui/SectionHeader";
import { FeatureCard } from "@/components/ui/FeatureCard";
import { cn } from "@/lib/utils";

const FEATURES = [
  {
    title: "Intent（日本円 → ステーブルコイン）",
    description:
      "日本円の銀行振込をトリガーに、ステーブルコイン（ERC-20 / 18 decimals）をユーザーウォレットへ送付。バーチャル口座の発行から入金照合、オンチェーン送金まで一括処理します。",
  },
  {
    title: "Redemption（ステーブルコイン → 日本円）",
    description:
      "ユーザーが ステーブルコイン を専用入金アドレスへ送付すると、オンチェーン検知後に銀行振込で日本円を払い戻し。申請ごとに一意のアドレスを生成し、ERC-20 の紐付けを簡易化します。",
  },
  {
    title: "セッション認証 / 2FA",
    description:
      "Cookie セッション（JWT / httpOnly）による認証と、TOTP ベースの二要素認証を標準搭載。セットアップ・検証を API で制御でき、セキュリティ要件に応じた運用が可能です。",
  },
  {
    title: "KYC / 本人確認",
    description:
      "オンボーディングフローに KYC ステータス管理を組み込み、未承認ユーザーの申請を制御。eKYC ベンダー連携の拡張にも対応できる設計です。",
  },
  {
    title: "バーチャル口座連携",
    description:
      "GMO あおぞらネット銀行等の銀行 API と連携し、Intent ごとに一意のバーチャル口座を自動発行。入金 Webhook を受けて申請との照合を自動化します。",
  },
  {
    title: "通知Webhook",
    description:
      "銀行入金通知（deposit webhook）とオンチェーン入金通知（crypto-payin webhook）を受信するエンドポイントを提供。外部の金融機関からの通知を統合的に処理します。",
  },
  {
    title: "マルチチェーン対応",
    description:
      "あらゆるEVM 互換チェーンに対応。申請時にチェーンを指定でき、RPC やアダプター（IChainAdapter）の切り替えは MBSC が内部で処理します。",
  },
  {
    title: "管理画面の提供",
    description:
      "ユーザー一覧・トランザクション履歴・ステーブルコイン 情報の参照を Admin API と MBSC SDKでバックエンド・フロントエンドの両方を提供。障害対応や照合、監査ログの確認に活用できます。",
  },
  {
    title: "Sandbox 環境",
    description:
      "実際の銀行振込なしで入金〜送金フローをテストできるサンドボックス。simulate-deposit API により、開発・検証を安全かつ迅速に進められます。",
  },
] as const;

export function MbscFeatures() {
  return (
    <section className="px-6 py-20 md:px-12">
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto max-w-4xl">
          <SectionHeader
            eyebrow="Features"
            title="日本円 ↔ Crypto に必要なすべてを、ひとつの基盤で。"
            description="入出金フロー・認証・オンチェーン送金・運用管理——
              日本円とステーブルコインの相互変換に求められる機能を一括提供します。"
          />
        </div>
        <div
          className={cn(
            "mt-14 grid gap-px overflow-hidden rounded-lg border border-border/60 bg-border/60 sm:grid-cols-2 lg:grid-cols-3",
          )}
        >
          {FEATURES.map((feature) => (
            <FeatureCard
              key={feature.title}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
